import {Asset} from "../accounting/asset/asset"
import {OrderBook} from "./orderbook"
import {Timer} from "../timer";
import axios from 'axios';

export class Market {
    static list(page, pageSize, options, url='futures/markets') {
        return new Promise((resolve, reject) => {
            axios
                .get(url, {
                    params: { page: page, pageSize: pageSize, ...options }
                })
                .then((response) => {
                    resolve(response.data.data.map(_market => Market.create(_market)))
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    static listByAdmin(page, pageSize, options) {
        options.active = true
        return Market.list(page, pageSize, options, 'futures/admin/markets')
    }

    static getBySymbols(baseSymbol, quoteSymbol) {
        if (baseSymbol == "AED" && quoteSymbol == "USDT")
            [baseSymbol, quoteSymbol] = [quoteSymbol, baseSymbol]
        if (baseSymbol == "IRT" && quoteSymbol == "AED")
            [baseSymbol, quoteSymbol] = [quoteSymbol, baseSymbol]
        return new Promise((resolve, reject) => {
            axios
                .get('futures/market/' + baseSymbol + '-' + quoteSymbol, { errorHandling: false })
                .then((response) => {
                    resolve(Market.create(response.data))
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    static create(data, pathFromRoot = null, setupType) {
        if (pathFromRoot == null)
            pathFromRoot = []
        if (data == null)
            return null
        if (data instanceof Market)
            return data
        for (let obj of pathFromRoot)
            if (obj instanceof Market && obj.id == data.id)
                return obj
        return new Market(data, pathFromRoot, setupType)
    }

    constructor(data, pathFromRoot, setupType = 'default') {
        if (setupType === 'bot') {
            this.setUpFromBot(data, pathFromRoot);
        } else {
            this.setUp(data, pathFromRoot);
        }
        this.loading = 0;
    }

    setUpFromBot(data, pathFromRoot) {
        pathFromRoot.push(this)
        this.id = data.id
        this.baseAsset = Asset.create(data.base_asset, null, 'bot')
        this.quoteAsset = Asset.create(data.quote_asset, null, 'bot')
        this.type = data.type
        this.priceDecimals = data.price_precision
        this.loading = 0
        pathFromRoot.pop()
    }

    setUp(data, pathFromRoot) {
        pathFromRoot.push(this)
        this.id = data.id
        this.active = data.active
        this.priceTtl = data.priceTtl
        this.type = data.type
        this.public = data.public
        this.originalPriceTtl = 10
        this.priceDecimals = data.priceDecimals
        this.baseAsset = Asset.create(data.baseAsset)
        this.quoteAsset = Asset.create(data.quoteAsset)
        this.sellOrderBook = OrderBook.create(data.sellOrderBook)
        this.buyOrderBook = OrderBook.create(data.buyOrderBook)
        this.bestPriceToBuy = this.sellOrderBook.bestPrice
        this.bestPriceToSell = this.buyOrderBook.bestPrice
        this.symbol = data.baseAsset.symbol + '-' + data.quoteAsset.symbol
        this.name = data.baseAsset.name + '-' + data.quoteAsset.name
        this.timer = new Timer(() => {}, 0)
        this.worstSellPrice = data.worstSellPrice
        this.worstBuyPrice = data.worstBuyPrice
        pathFromRoot.pop()
    }

    setFetchCallback(callback) {
        this.fetchCallback = (market) => { callback(market) }
    }

    retrieve() {
        if (this.loading) return
        this.loading += 1
        if (this.timer != null)
            this.timer.end()
        return Market.getBySymbols(this.baseAsset.symbol, this.quoteAsset.symbol)
            .then((market) => {
                this.setUp(market, [])
                this.fetchCallback(this)
            })
            .catch(() => { })
            .finally(() => {
                this.loading -= 1
                this.restartTimer()
            })
    }

    restartTimer() {
        if (this.timer != null)
            this.timer.end()
        this.timer = new Timer(this.retrieve.bind(this), this.originalPriceTtl)
        this.timer.restart()
    }

    isLoading() {
        return this.loading > 0
    }

    getReverseOrderBookBySide(side) {
        if (side == 'Buy')
            return this.sellOrderBook
        return this.buyOrderBook
    }

    toDto() {
        return {
            id: this.id,
            buyPrice: this.worstBuyPrice,
            sellPrice: this.worstSellPrice
        }
    }
    
    save() {
        return new Promise((resolve, reject) => {
            this.loading += 1
            axios.put(
                'market/' + this.id,
                this.toDto()
            )
                .then((response) => {
                    resolve(Market.create(response.data))
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    this.loading -= 1
                })
        })
    }
}
